import jwtDecode from 'jwt-decode';
import Cookies, { getLastCartCookieName } from '../../utils/Cookies';
import { COOKIES } from '../../constants';
import UserService from '../../services/UserService';

export const setAuthenticatedCookies = jwtToken => {
  const secure = process.env.REACT_APP_PROTOCOL === 'https:';

  Cookies.set(COOKIES.LOGGED_IN, true);
  Cookies.set(COOKIES.COGNITO_ID, jwtDecode(jwtToken).sub);
  Cookies.set(COOKIES.COGNITO_JWT, jwtToken, { secure });
};

export const clearUserCookies = async () => {
  Cookies.remove(COOKIES.LOGGED_IN);
  Cookies.remove(COOKIES.COGNITO_ID);
  Cookies.remove(COOKIES.COGNITO_JWT);
  Cookies.remove(COOKIES.XSRF_TOKEN);
  Cookies.remove(COOKIES.REMEMBER_TOKEN);
  Cookies.remove(COOKIES.FAVOURITES_LIST_ID);
  Cookies.remove(COOKIES.ANONYMOUS_BASKET_COOKIE);
  Cookies.remove(COOKIES.AWS_CREDENTIALS_COOKIE);
  if (Cookies.get(COOKIES.NEW_BASKET_ENABLED)) {
    Cookies.remove(getLastCartCookieName());
  }

  await UserService.clearNothsSession();
};
